import React from 'react';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTrigger,
} from '@design-system/Sheet';
import { InfoIcon } from 'lucide-react';
import { Image } from '@design-system/Image';
import { getBoostersAndBlockersImageUrl } from '@/utils/nutrition/getImageUrl';

export interface InfoSheetProps {
  title: string;
  description: string;
  imageUrl?: string;
  mode?: string;
}

export const InfoSheet: React.FC<InfoSheetProps> = ({
  title,
  description,
  imageUrl = null,
  mode = 'dark',
}) => {
  return (
    <Sheet>
      <SheetTrigger className="mx-1.5 items-center">
        <span>
          <InfoIcon
            className="h-4 w-4 -mb-[3px]"
            aria-label={`Information about ${title}`}
          />
        </span>
      </SheetTrigger>
      <SheetContent className={mode}>
        <SheetHeader>
          {imageUrl && (
            <div className="flex justify-center">
              <Image
                className="w-[11.25rem] h-[11.25rem] object-cover"
                src={getBoostersAndBlockersImageUrl(imageUrl)}
                alt={title}
              />
            </div>
          )}
          <SheetDescription className="pl-0 flex flex-col">
            <span className="typography-h1 text-primary">{title}</span>
            <span className="typography-body text-secondary whitespace-pre-line pt-4">
              {description}
            </span>
          </SheetDescription>
        </SheetHeader>
      </SheetContent>
    </Sheet>
  );
};
